<script>
import { eventBus } from "../main";
import navigation from "../mixins/navigation.js";
export default {
  mixins: [navigation],
  name: "app",
  data() {
    return {
      last: "P_6",
      next: "P_8",
      topic: "Taller ¿Qué es crédito? / ¡Estoy listo para cursar esta lección!",
      progress: false,
      questions: 6
    };
  },
  methods: {
    recordScore() {
      this.progress = true;
      eventBus.$emit("record_score", evaluation);
    },
  }
};
</script>

<template lang="pug">
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs11, sm10, md10, lg9)
          v-card(flat, text-xs-center)
            breadcrumb(:back='last') Estás en: {{topic}}
            v-layout.px-4(row, wrap, justify-start)
              v-flex(xs12, md6)
                v-card(flat)
                  v-img(height='576px', :src='require("@/assets/TCC-L1-Pagina7 A.png")')
              v-flex(xs12, md6)
                v-card.ml-0.pl-0(flat, text-xs-start)
                  v-card-text.titulo48Book.ml-0.pl-0
                    b ¡Gracias por tus respuestas!              
                  v-card-text.parrafoRetro14B.ml-0.pl-0
                    | Es momento de resolver dudas, ampliar tus conocimientos y elegir el crédito que más te conviene.
                  v-card-text.parrafoRetro14B.ml-0.pl-0
                    b ¡Bienvenido a ¿Qué es crédito?
            v-layout(row, justify-center)
              v-btn.btn(justify-space-between, type='button ', color='primary ', @click.prevent="nextChapter(next)")
                | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>


